import { AccessType } from 'app/auth/accessControlService'
import { Routes } from 'app/services/routeService/routeService'

import Login from './Login'
import LoginV4 from './V4/LoginV4'

export const LoginConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: Routes.login(),
      component: Login,
      accesses: [AccessType.ANNONYMOUS],
    },
    {
      path: [Routes.signIn(), Routes.facebookCallback()],
      component: LoginV4,
      accesses: [AccessType.ANNONYMOUS],
    },
  ],
}
